import component from './ja-JP/component.json';
import menu from './ja-JP/menu.json';
import pages from './ja-JP/pages.json';
import settings from './ja-JP/settings.json';
import error from './ja-JP/error.json';
import role from './ja-JP/role.json';

export default {
  'app.copyright.company': 'T-connect Co., Ltd.',
  'navBar.lang': '言語',
  'layout.user.link.help': 'ヘルプ',
  'layout.user.link.privacy': 'プライバシー',
  'layout.user.link.terms': '利用規約',
  'app.preview.down.block': 'このページをローカルプロジェクトにダウンロードしてください',
  'app.welcome.link.fetch-blocks': '',
  'app.welcome.link.block-list': '',
  ...menu,
  ...settings,
  ...component,
  ...pages,
  ...error,
  ...role,
};
